module.exports = __webpack_public_path__ + "static/media/ios-arrow-forward.34ad6427.svg";